<i18n locale="en">
{
  "actions": {
    "fix": "Update payment method"
  },
  "labels": {
    "title": "Payment failed for {locationName}",
    "body": "We haven't been able to process payment for this location.  Please update your payment method."
  }
}
</i18n>

<template>
  <OwnCallout
    v-if="hasLocationsUnderCollections"
    :title="title"
    :body="t('labels.body')"
    type="danger"
    :click-handler="onFixClick"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

import { useActiveBrand } from '@/core/store'
import { usePastDueLocationsQuery } from '@/features/billing/queries/usePastDueLocationsQuery'
import { OwnCallout } from '@/ui/OwnCallout'

const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const { activeBrandId, locations } = useActiveBrand()
const { data: pastDueData } = usePastDueLocationsQuery(activeBrandId)

const locationsUnderCollections = computed(() => {
  const pastDueLocationIds = new Set(pastDueData.value?.locationIds ?? [])

  return locations.value
    .filter(
      (location) =>
        pastDueLocationIds.has(location.id) && location.status !== 'cancelled'
    )
    .map((location) => ({ id: location.id, name: location.name }))
})

const hasLocationsUnderCollections = computed(
  () => locationsUnderCollections.value.length > 0
)

const title = computed(() => {
  if (locationsUnderCollections.value.length) {
    return t('labels.title', {
      locationName: locationsUnderCollections.value[0]?.name,
    })
  }

  return undefined
})

const isOnCollectionsPage = computed(() => {
  return route?.name === 'brand.billing.methods'
})

const onFixClick = async () => {
  if (!isOnCollectionsPage.value) {
    await router.push({
      name: 'brand.billing.methods',
    })
  }
}
</script>
